export const figmaColors = {
  transparent: "rgba(0, 0, 0, 0)",
  accent: "#469428",
  discover: "#3A09FF",
  discoverExtraLight: "#F1FBFF",
  foundation: "#212121",
  shadow: "#666666",
  silver: "#CDCDCD",
  smooth: "#EEEEEE",
  fade: "#FAFAFA",
  clear: "#FFFFFF",

  allergy: "#F42966",
  avoid: "#F2994A",
  info: "#70A5AC",
  recommended: "#99CC00",
  avoidSoft: "#FFFADE",
  allergySoft: "#FFF5F5",
  infoSoft: "#F5FDFF",
  recommendedSoft: "#F8FFF5",
  allergyHard: "#CC0B45",

  extras: {
    discoverXXLight: "#F3EFFF",
    warningXXLight: "#FBF7ED",
  },
};

export const figmaNewColors = {
  green: {
    50: "#F8FFF5",
    100: "#ECFFE3",
    200: "#DAFFC8",
    300: "#BCFFA3",
    400: "#A6FA85",
    500: "#88EA62",
    600: "#63D936",
    700: "#4FBD25",
    800: "#3EA815",
    900: "#469428",
  },
  brightGreen: {
    50: "#F9FFE7",
    100: "#F0FFC2",
    200: "#E4FE98",
    300: "#D8FD69",
    400: "#CDFA3F",
    500: "#CCFF00",
    600: "#C1EB00",
    700: "#B1D400",
    800: "#A3BC00",
    900: "#8C9300",
  },
  red: {
    50: "#FFFAFA",
    100: "#FFF5F5",
    200: "#FFC8C8",
    300: "#FFB4B4",
    400: "#FFA0A0",
    500: "#FF8B8B",
    600: "#FF6D6D",
    700: "#FE487F",
    800: "#F42966",
    900: "#FF1A5E",
  },
  orange: {
    50: "#FFF7E0",
    100: "#FFEAB1",
    200: "#FFDC7E",
    300: "#FFD04A",
    400: "#FFC41F",
    500: "#FFBA00",
    600: "#FFAC00",
    700: "#FF9900",
    800: "#FF8700",
    900: "#FF6600",
  },
  yellow: {
    50: "#FFFCE5",
    100: "#FFF7BE",
    200: "#FFF292",
    300: "#FFED65",
    400: "#FEE83D",
    500: "#FFE600",
    600: "#FED200",
    700: "#FDB900",
    800: "#FDA000",
    900: "#FB7300",
  },
  blue: {
    50: "#F5FDFF",
    100: "#E1F5FD",
    200: "#82D5F6",
    300: "#51C4F2",
    400: "#2DB7F1",
    500: "#05ABEF",
    600: "#009DE0",
    700: "#008ACC",
    800: "#0079B9",
    900: "#0060B9",
  },
  electricBlue: {
    50: "#F3EFFF",
    100: "#CCBFFF",
    200: "#B5A3FF",
    300: "#9C83FF",
    400: "#8C70FF",
    500: "#7A58FF",
    600: "#6944FF",
    700: "#562CFF",
    800: "#491CFF",
    900: "#3A09FF",
  },
  darkBlue: {
    50: "#ECE5F6",
    100: "#CEBEE9",
    200: "#AD93DB",
    300: "#8C67CE",
    400: "#7246C4",
    500: "#5724B9",
    600: "#4D1FB4",
    700: "#3E17AB",
    800: "#2E10A4",
    900: "#000099",
  },
  purple: {
    50: "#F3E4F5",
    100: "#E0BAE6",
    200: "#CD8DD6",
    300: "#B85FC5",
    400: "#A939B9",
    500: "#9907AD",
    600: "#8B06A8",
    700: "#7802A0",
    800: "#660099",
    900: "#44008D",
  },
  netural: {
    50: "#FFFFFF",
    100: "#FAFAFA",
    200: "#F1F1F1",
    300: "#ECECEC",
    400: "#DEDEDE",
    500: "#CBCBCB",
    600: "#B5B5B5",
    700: "#A0A0A0",
    800: "#868686",
    900: "#7E7E7E",
  },
  darkGrey: {
    50: "#777777",
    100: "#646464",
    200: "#565656",
    300: "#4A4A4A",
    400: "#3E3E3E",
    500: "#353535",
    600: "#222222",
    700: "#111111",
    800: "#090909",
    900: "#000000",
  },
};
